import { NavigableButton } from '@carvana/ds-button';
import React, { useCallback } from 'react';
import useScrollToSection from '~/hooks/vdp/useScrollToSection';

export type OwnProps = React.DetailedHTMLProps<
  React.AnchorHTMLAttributes<HTMLAnchorElement>,
  HTMLAnchorElement
> &
  React.PropsWithChildren<{}>;

export default function NavigationLink({
  children,
  'data-analytics-id': dataAnalyticsId,
  'data-analytics-attributes': dataAnalyticsAttributes = '',
  href,
  ...props
}: OwnProps) {
  const scrollToSection = useScrollToSection();
  const idWithoutHash = href?.slice(1);

  const onClick = useCallback<React.MouseEventHandler<HTMLAnchorElement>>(
    e => {
      if (!idWithoutHash) return;

      e.preventDefault();
      // e.detail is 0 for keyboard-triggered clicks — skip blur to preserve focus for keyboard users
      if (e.detail > 0) e.currentTarget.blur();
      scrollToSection(idWithoutHash);
    },
    [idWithoutHash, scrollToSection]
  );

  return (
    <NavigableButton
      data-adobe-id={null}
      data-analytics-attributes={dataAnalyticsAttributes}
      data-analytics-id={dataAnalyticsId}
      data-testid="navigation-link"
      href={href}
      onClick={onClick}
      size="sm"
      variant="primaryInverted"
      {...props}
    >
      {children}
    </NavigableButton>
  );
}
